/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesbyCategoryAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: SalesbyCategoryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';
import { SalesbyCategoryData, SalesbyCategoryService }  from './SalesbyCategory.service';


@Component({
  template: require('./SalesbyCategoryDetails.component.html'),
  providers: [SalesbyCategoryService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SalesbyCategoryDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objSalesbyCategory: SalesbyCategoryData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private SalesbyCategoryService: SalesbyCategoryService

	) {
		// this.id = parseInt(params.get('id'));
		this.objSalesbyCategory = new SalesbyCategoryData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.SalesbyCategoryService.getByID(+params['id']))
		.switchMap((params: Params) => this.SalesbyCategoryService.getByID(params['id']))
		.subscribe((item: SalesbyCategoryData) => this.objSalesbyCategory = item);
		this.getLookups();
	}

	deleteSalesbyCategory(id: string) {
		if (window.confirm('Are you sure you want to delete this SalesbyCategory?') == true) 
		{
			this.SalesbyCategoryService.deleteSalesbyCategory(this.objSalesbyCategory.CategoryID.toString())
			.subscribe(record => this.router.navigate(['/SalesbyCategory']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('SalesbyCategory record deleted successfully...'); }
			);
		}
	}
	gotoSalesbyCategoryEdit() {
		this.router.navigate(['/SalesbyCategory', this.objSalesbyCategory.CategoryID]);
	}

	gotoSalesbyCategory() {
		this.router.navigate(['/SalesbyCategory']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SalesbyCategory/SalesbyCategoryDetails.component.ts